import React from "react";

const ArtOfFacingChallenges = () => {
    return (
        <main>
            <div className="container">
                <div className="row center">
                    <div className="video-container">
                        <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/CxQgFxCFaIM?si=R4VL2y0239BvsgRc"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default ArtOfFacingChallenges;
